import { connect } from 'react-redux'
import SsoLogin from './SsoLogin'
import { handleSsoQuery } from './module'

const mapActionCreators = {
  handleSsoQuery,
}

const mapStateToProps = state => ({
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(SsoLogin)



// WEBPACK FOOTER //
// ./src/legacy/pages/SsoLogin/container.js